import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

// Actions
import { getCampaignPlan } from "../../../actions/campaign-plan/CampaignPlanActions";
import { getBasicCampaignDetails } from "../../../actions/campaign/CampaignBasicInfoActions";
import { getRoadStretchesByCityId } from "../../actions/campaign-planning/CampaignPlanningRoadStretchesActions";

// Utils
import { useGetTgInfo } from "../../../mavin/utils/hooks/HooksUtil";

// Components
import Spinner from "../../../components/spinner/Spinner";
import PageHeader from "../../../mavin/components/page-header/PageHeader";
import MediaDetailsTable from "../components/MediaDetailsTable";
import MapView from "../components/map-view/MapView";
import CityViewCards from "../components/CityViewCards";
import CampaignSidebar from "../../../components/campaign-sidebar/CampaignSidebar";
import { CampaignDetails } from "../components/HeaderNav";

/**
 * Page
 */
export default function CampaignCancelPage() {
  const dispatch = useDispatch();
  const { campaignId, cityId } = useParams();

  // Get campaignPlan
  const campaignPlan = useSelector((state) => state.campaignPlan.campaignPlan);
  const { targetGroupId, isDigital } = campaignPlan || {};

  // Get campaign
  const campaign = useSelector((state) => state.c_campaignBasicInfo.campaign);

  // Campaign Media
  const campaignMedia = useSelector(
    (state) => state.campaignMedia.campaignMedia
  );

  // City road stretches
  const roadStretchMap = useSelector(
    (state) => state.planningRoadStretches.roadStretchDetailsMap
  );

  // Loadings
  const campaignPlanLoading = useSelector(
    (state) => state.campaignPlan.campaignPlanLoading
  );
  const basicCampaignDetailsLoading = useSelector(
    (state) => state.c_campaignBasicInfo.campaignLoading
  );
  const roadStretchesByCityIdLoading = useSelector(
    (state) => state.planningRoadStretches.loading
  );
  const tgInfoLoading = useSelector(
    (state) => state.orgTargetGroup.tgInfoLoading
  );

  const isPageLoading =
    campaignPlanLoading ||
    basicCampaignDetailsLoading ||
    roadStretchesByCityIdLoading ||
    tgInfoLoading;

  // Dispatch
  useEffect(() => {
    dispatch(getCampaignPlan(campaignId, cityId));
    dispatch(getBasicCampaignDetails(campaignId));
  }, [dispatch, campaignId, cityId]);

  // road stretches
  useEffect(() => {
    if (Object.keys(campaignPlan).length > 0) {
      dispatch(getRoadStretchesByCityId(cityId, "", isDigital));
    }
  }, [dispatch, JSON.stringify(campaignPlan)]);

  // get tg info
  useGetTgInfo(targetGroupId);

  // Sidebar Settings
  const citySelected = { cityId };
  const redirectLinkObj = {
    campaignOverviewLink: `/campaign/${campaignId}/cancel`,
    citySummaryLink: `/campaign/${campaignId}/city/:cityId/cancel`,
  };

  // Page Title
  const pageTitle = <CampaignDetails campaign={campaign} />;

  // page loading
  if (isPageLoading) {
    return <Spinner className="spinner-center mt-2" />;
  }

  return (
    <>
      {/* SideBar */}
      <CampaignSidebar
        campaign={campaign}
        citySelected={citySelected}
        redirectLinkObj={redirectLinkObj}
      />

      <div className="content-wrapper">
        <PageHeader title={pageTitle} shadow={true} />

        <div className="page-content">
          <CityViewCards
            campaign={campaign}
            cityPlan={campaignPlan}
            campaignMedia={campaignMedia}
          />

          {/* Map view */}
          <MapView
            campaignPlan={campaignPlan}
            roadStretchMap={roadStretchMap}
          />

          {/* Media Sites Table */}
          <MediaDetailsTable
            campaignId={campaignId}
            campaign={campaign}
            campaignPlan={campaignPlan}
            roadStretchMap={roadStretchMap}
          />
        </div>
      </div>
    </>
  );
}
